const PRODUCT_TYPES = {
  VIDEO: 'video',
  DIGITAL: 'digital',
};

export default PRODUCT_TYPES;
